<template>
  <v-flex d-block xs12>
    <v-dialog v-model="dialog" width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">{{dialogTitle}}</span>
        </v-card-title>
        <v-card-text>
          <ul class="cases">
            <li v-for="(c, index) in dialogCases" :key="index">{{c.title}}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <h2 style="width: 100%;">Materials</h2>
          <v-flex xs4>
            <bar-chart :chartData="tissueBar" :chart-id="0" style="min-height: 400px" :options="stackedOptionsBar"></bar-chart>
          </v-flex>
          <v-flex xs4>
            <bar-chart :chartData="blockBar" :chart-id="0" style="min-height: 400px" :options="stackedOptionsBar"></bar-chart>
          </v-flex>
          <v-flex xs4>
            <bar-chart :chartData="slidesBar" :chart-id="0" style="min-height: 400px" :options="stackedOptionsBar"></bar-chart>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs4>
            <bar-chart :chartData="scanningBar" :chart-id="0" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
          </v-flex>
          <v-flex xs4>
            <bar-chart :chartData="microtomyBar" :chart-id="0" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
          </v-flex>
          <v-flex xs4>
            <bar-chart :chartData="grossingBar" :chart-id="0" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <h2 style="width: 100%;">Created Slides</h2>
          <v-flex xs4 v-for="item in laborants" :key="item.id">
            <h4>{{item.name}}</h4>
            <bar-chart :chartData="item.bar" :chart-id="item.id" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <h2 style="width: 100%;">Grossing Block</h2>
          <v-flex xs4 v-for="item in doctors" :key="item.id">
            <h4>{{item.name}}</h4>
            <bar-chart :chartData="item.bar" :chart-id="item.id" style="min-height: 400px" :options="generalOptionsBar"></bar-chart>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
import BarChart from '../Charts/Bar'
import api from '../../api'
import moment from 'moment'

export default {
  name: 'cases',
  components: {
    BarChart
  },
  data () {
    return {
      loading: false,
      scanningBar: null,
      microtomyBar: null,
      grossingBar: null,
      tissueBar: null,
      blockBar: null,
      slidesBar: null,
      dialogTitle: '',
      dialogCases: [],
      dialog: false,
      stackedOptionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales:
          {
            yAxes: [
              {
                stacked: true,
                ticks:
                  {
                    beginAtZero: true,
                    suggestedMax: 200
                  }
              }],
            xAxes: [{
              stacked: true
            }]
          },
        onClick: this.onClickChart
      },
      doctors: [],
      laborants: [],
      isStacked: false,
      generalOptionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales:
          {
            yAxes: [
              {
                ticks:
                  {
                    beginAtZero: true,
                    suggestedMax: 200
                  }
              }]
          }
      }
    }
  },
  created () {
    try {
      this.getPreparationPerformance()
    } catch (e) {
      this.showApiError(this, e, 'Unable to draw charts')
    }
  },
  methods: {
    async onClickChart (e, row) {
      if (!row || row.length === 0) {
        return
      }

      this.dialogCases = []
      this.dialogTitle = ''

      let chart = row[0]._chart
      let firstPoint = chart.getElementAtEvent(e)[0]

      if (firstPoint) {
        let yLabel = chart.data.labels[firstPoint._index]
        let xLabel = chart.data.datasets[firstPoint._datasetIndex].label.split(' ')

        let result = await api.getCasesByParams(yLabel.toLowerCase(), xLabel[0].toLowerCase(), xLabel[1].toLowerCase())
        this.dialogTitle = 'Cases for Date: ' + yLabel + ' Material: ' + chart.data.datasets[firstPoint._datasetIndex].label
        this.dialogCases = result.cases
        this.dialog = true
      }
    },
    async getPreparationPerformance () {
      this.loading = true

      let result = await api.getPreparationPerformance()

      let lastMonth = Array.apply(null, Array(31)).map((_, i) => { return moment().subtract(i, 'days').format('YYYY-MM-DD') })
      lastMonth.reverse()

      let uploadedSlides = result.uploadedSlides
      let grossingCase = result.grossingCase
      let slidesCreated = result.slidesCreated

      uploadedSlides.sort((a, b) => { return new Date(a.ended_at) - new Date(b.ended_at) })
      grossingCase.sort((a, b) => { return new Date(a.ended_at) - new Date(b.ended_at) })
      slidesCreated.sort((a, b) => { return new Date(a.ended_at) - new Date(b.ended_at) })

      let scanLabels = []
      let scanDataset = []
      for (let item of uploadedSlides) {
        let d = item.ended_at.split('T')[0]
        if (scanLabels.indexOf(d) === -1) {
          scanLabels.push(d)
          scanDataset.push(item.count)
        }
      }

      this.scanningBar = {
        labels: scanLabels,
        datasets: [{
          label: 'Scanned Slides',
          backgroundColor: '#29B6F6',
          data: scanDataset
        }]
      }

      let microtomyDataset = Array.apply(0, Array(31))
      for (let item of result.microtomyCreated) {
        let i = lastMonth.indexOf(item.ended_at.split('T')[0])
        microtomyDataset[i] = item.count
      }

      this.microtomyBar = {
        labels: lastMonth,
        datasets: [{
          label: 'Microtomy Slides',
          backgroundColor: '#29B6F6',
          data: microtomyDataset
        }]
      }

      let grossingDataset = Array.apply(0, Array(31))
      for (let item of result.grossingCreated) {
        let i = lastMonth.indexOf(item.ended_at.split('T')[0])
        grossingDataset[i] = item.count
      }

      this.grossingBar = {
        labels: lastMonth,
        datasets: [{
          label: 'Grossing Block',
          backgroundColor: '#29B6F6',
          data: grossingDataset
        }]
      }

      let tissueDoneDataset = Array.apply(0, Array(31))
      let tissueGrossingDataset = Array.apply(0, Array(31))
      for (let item of lastMonth) {
        let done = 0
        let grossing = 0
        for (let tg of result.tissueDone) {
          if (tg.created_at.indexOf(item) > -1) {
            done = tg.count
          }
        }
        for (let tg of result.tissueGrossing) {
          if (tg.created_at.indexOf(item) > -1) {
            grossing = tg.count
          }
        }

        let i = lastMonth.indexOf(item)
        tissueDoneDataset[i] = done
        tissueGrossingDataset[i] = grossing
      }

      this.tissueBar = {
        labels: lastMonth,
        datasets: [{
          label: 'Tissue Done',
          backgroundColor: '#29B6F6',
          data: tissueDoneDataset
        }, {
          label: 'Tissue Grossing',
          backgroundColor: '#f6601b',
          data: tissueGrossingDataset
        }]
      }

      let blockDoneDataset = Array.apply(0, Array(31))
      let blockGrossingDataset = Array.apply(0, Array(31))
      let blockEmbeddingDataset = Array.apply(0, Array(31))
      let blockMicrotomyDataset = Array.apply(0, Array(31))
      for (let item of lastMonth) {
        let done = 0
        let grossing = 0
        let embedding = 0
        let microtomy = 0
        for (let h of result.histoblockDone) {
          if (h.created_at.indexOf(item) > -1) {
            done = h.count
          }
        }
        for (let h of result.histoblockGrossing) {
          if (h.created_at.indexOf(item) > -1) {
            grossing = h.count
          }
        }
        for (let h of result.histoblockMicrotomy) {
          if (h.created_at.indexOf(item) > -1) {
            microtomy = h.count
          }
        }
        for (let h of result.histoblockEmbedding) {
          if (h.created_at.indexOf(item) > -1) {
            embedding = h.count
          }
        }

        let i = lastMonth.indexOf(item)
        blockDoneDataset[i] = done
        blockGrossingDataset[i] = grossing
        blockEmbeddingDataset[i] = embedding
        blockMicrotomyDataset[i] = microtomy
      }

      this.blockBar = {
        labels: lastMonth,
        datasets: [{
          label: 'Block Done',
          backgroundColor: '#29B6F6',
          data: blockDoneDataset
        }, {
          label: 'Block Grossing',
          backgroundColor: '#f6601b',
          data: blockGrossingDataset
        }, {
          label: 'Block Embedding',
          backgroundColor: '#9039f6',
          data: blockEmbeddingDataset
        }, {
          label: 'Block Microtomy',
          backgroundColor: '#f6d406',
          data: blockMicrotomyDataset
        }]
      }

      let slideDoneDataset = Array.apply(0, Array(31))
      let slideScanningDataset = Array.apply(0, Array(31))
      let slideStainingDataset = Array.apply(0, Array(31))
      let slideMicrotomyDataset = Array.apply(0, Array(31))
      for (let item of lastMonth) {
        let done = 0
        let scanning = 0
        let staining = 0
        let microtomy = 0
        for (let h of result.slidesDone) {
          if (h.created_at.indexOf(item) > -1) {
            done = h.count
          }
        }
        for (let h of result.slidesMicrotomy) {
          if (h.created_at.indexOf(item) > -1) {
            microtomy = h.count
          }
        }
        for (let h of result.slidesScanning) {
          if (h.created_at.indexOf(item) > -1) {
            scanning = h.count
          }
        }
        for (let h of result.slidesStaining) {
          if (h.created_at.indexOf(item) > -1) {
            staining = h.count
          }
        }

        let i = lastMonth.indexOf(item)
        slideDoneDataset[i] = done
        slideScanningDataset[i] = scanning
        slideStainingDataset[i] = staining
        slideMicrotomyDataset[i] = microtomy
      }

      this.slidesBar = {
        labels: lastMonth,
        datasets: [{
          label: 'Slide Done',
          backgroundColor: '#29B6F6',
          data: slideDoneDataset
        }, {
          label: 'Slide Scanning',
          backgroundColor: '#5ff626',
          data: slideScanningDataset
        }, {
          label: 'Slide Staining',
          backgroundColor: '#9039f6',
          data: slideStainingDataset
        }, {
          label: 'Slide Microtomy',
          backgroundColor: '#f6d406',
          data: slideMicrotomyDataset
        }]
      }

      let laborants = []
      for (let item of slidesCreated) {
        if (laborants.indexOf(item.name) === -1) {
          laborants.push(item.name)
        }
      }

      let doctors = []
      for (let item of grossingCase) {
        if (doctors.indexOf(item.name) === -1) {
          doctors.push(item.name)
        }
      }

      let chartId = 1
      for (let lab of laborants) {
        let labDataset = Array.apply(0, Array(31))
        chartId++
        for (let item of slidesCreated) {
          if (item.name !== lab) {
            continue
          }
          let i = lastMonth.indexOf(item.ended_at.split('T')[0])
          labDataset[i] = item.count
        }
        this.laborants.push({
          id: chartId,
          name: lab,
          bar: {
            labels: lastMonth,
            datasets: [{
              label: 'Created Slides',
              backgroundColor: '#29B6F6',
              data: labDataset
            }]
          }
        })
      }

      for (let doc of doctors) {
        let docDataset = Array.apply(0, Array(31))
        chartId++
        for (let item of grossingCase) {
          if (item.name !== doc) {
            continue
          }
          let i = lastMonth.indexOf(item.ended_at.split('T')[0])
          docDataset[i] = item.count
        }
        this.doctors.push({
          id: chartId,
          name: doc,
          bar: {
            labels: lastMonth,
            datasets: [{
              label: 'Grossing Block',
              backgroundColor: '#29B6F6',
              data: docDataset
            }]
          }
        })
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
  ul.cases {
    columns: 6;
    -webkit-columns: 6;
    -moz-columns: 6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Diagnostics/Preparation.vue